import {
  HStack,
  Select,
  Button,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

interface NotificationFiltersProps {
  typeFilter: string;
  statusFilter: string;
  onTypeFilterChange: (type: string) => void;
  onStatusFilterChange: (status: string) => void;
  onMarkAllAsRead: () => void;
  unreadCount: number;
}

/**
 * Notification Filters Component
 * Provides filtering and bulk actions
 */
export function NotificationFilters({
  typeFilter,
  statusFilter,
  onTypeFilterChange,
  onStatusFilterChange,
  onMarkAllAsRead,
  unreadCount,
}: NotificationFiltersProps) {
  const filterLabelColor = useColorModeValue('gray.700', 'gray.300');
  const selectBg = useColorModeValue('white', 'gray.700');

  return (
    <HStack spacing={4} flexWrap="wrap">
      <HStack>
        <Text color={filterLabelColor} fontWeight="medium">
          Filter by Type:
        </Text>
        <Select
          value={typeFilter}
          onChange={(e) => onTypeFilterChange(e.target.value)}
          bg={selectBg}
          maxW="200px"
        >
          <option value="all">All Types</option>
          <option value="rock_created">Rock Created</option>
          <option value="rock_updated">Rock Updated</option>
          <option value="rock_completed">Rock Completed</option>
          <option value="rock_dropped">Rock Dropped</option>
          <option value="issue_created">Issue Created</option>
          <option value="issue_resolved">Issue Resolved</option>
          <option value="action_item_created">Action Item Created</option>
          <option value="action_item_completed">Action Item Completed</option>
          <option value="metric_created">Metric Created</option>
          <option value="metric_off_track">Metric Off Track</option>
          <option value="wins_excited_created">Wins & Excited</option>
        </Select>
      </HStack>
      <HStack>
        <Text color={filterLabelColor} fontWeight="medium">
          Filter by Status:
        </Text>
        <Select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          bg={selectBg}
          maxW="200px"
        >
          <option value="all">All</option>
          <option value="unread">Unread</option>
          <option value="read">Read</option>
        </Select>
      </HStack>
      {unreadCount > 0 && (
        <Button
          size="sm"
          colorScheme="blue"
          variant="outline"
          onClick={onMarkAllAsRead}
        >
          Mark All as Read ({unreadCount})
        </Button>
      )}
    </HStack>
  );
}

